import React, { Component } from 'react';
import { connect } from 'react-redux';
import RfqModal from '../../RfqModal';
import RegisterPromptModal from '../../RegisterPromptModal';
import { getActiveProject, getUpdateParameters, getParameters } from '../../../reducers/mainReducer';
import { compareParameters } from '../../../actions/parametersActions';
import quoteCartService from '../../../services/quoteCartService';
import authService from '../../../services/authService';
import './StepQuote.css';

export class StepQuote extends Component {
    constructor(props) {
        super(props);
        this._isMounted = false;
        this.state = {
            showRfqModal: false,
            addingToQuote: false,
            addedToFolder: false,
            addToQuoteError: '',
            showRegisterPrompt: false
        };
        this.openRfqModal = this.openRfqModal.bind(this);
        this.closeRfqModal = this.closeRfqModal.bind(this);
        this.handleAddToQuote = this.handleAddToQuote.bind(this);
        this.handleLeave = this.handleLeave.bind(this);
        this.handleLogout = this.handleLogout.bind(this);
    }

    componentDidMount() {
        this._isMounted = true;
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    openRfqModal() {
        this.setState({ showRfqModal: true });
    }

    closeRfqModal() {
        this.setState({ showRfqModal: false });
    }

    async handleAddToQuote() {
        const parameterList = this.props.projectUpdateParameters || [];
        const configurationJson = parameterList.reduce((acc, param) => {
            acc[param.name] = { value: param.value, units: param.units };
            return acc;
        }, {});

        const productName = this.props.activeProject?.id || 'Unknown Product';
        const productDisplayName = this.props.activeProject?.label || productName;

        this.setState({ addingToQuote: true, addToQuoteError: '' });

        try {
            await quoteCartService.addItem({
                productName,
                productDisplayName,
                configurationJson: JSON.stringify(configurationJson),
                quantity: 1
            });
            if (this._isMounted) {
                this.setState({ addedToFolder: true, addingToQuote: false });
            }
            if (this.props.onCartUpdated) {
                this.props.onCartUpdated();
            }
        } catch (err) {
            if (this._isMounted) {
                this.setState({
                    addToQuoteError: err.message || 'Failed to add to quote folder',
                    addingToQuote: false
                });
            }
            setTimeout(() => {
                if (this._isMounted) {
                    this.setState({ addToQuoteError: '' });
                }
            }, 5000);
        }
    }

    handleLeave() {
        if (document.referrer && document.referrer !== window.location.href) {
            window.location.href = document.referrer;
        } else {
            window.close();
            window.location.href = '/';
        }
    }

    handleLogout() {
        authService.logout();
        window.location.reload();
    }

    render() {
        const parameterList = this.props.projectUpdateParameters || [];
        const sourceParams = this.props.projectSourceParameters || [];
        const configurationJson = parameterList.reduce((acc, param) => {
            acc[param.name] = param.value;
            return acc;
        }, {});
        const productName = this.props.activeProject?.id || 'Unknown Product';
        const productLabel = this.props.activeProject?.label || productName;
        const isAnonymous = this.props.isAnonymous;
        const hideQuoteButtons = this.props.hideQuoteButtons;
        const { addedToFolder } = this.state;

        return (
            <div className="step-quote-layout">

                {/* Left Column: Configuration Summary */}
                <div className="step-quote-left">
                    <div className="step-quote-section">
                        <div className="step-quote-section-title">Your Configuration</div>
                        <div className="step-quote-card">
                            <div className="step-quote-product-name">{productLabel}</div>
                            {parameterList.length > 0 ? (
                                <table className="step-quote-params-table">
                                    <thead>
                                        <tr>
                                            <th>Option</th>
                                            <th>Selected Value</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {parameterList.map((param, index) => {
                                            const sourceParam = sourceParams.find(s => s.name === param.name);
                                            const changed = sourceParam && !compareParameters(param, sourceParam);
                                            return (
                                                <tr key={index} className={changed ? 'step-quote-param-changed' : ''}>
                                                    <td>{param.label || param.name}</td>
                                                    <td>
                                                        {param.value}
                                                        {changed && <span className="step-quote-changed-badge">Modified</span>}
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            ) : (
                                <p className="step-quote-no-data">No configuration parameters available.</p>
                            )}
                        </div>
                    </div>

                </div>

                {/* Right Column: Quote Options & Actions */}
                <div className="step-quote-right">
                    <div className="step-quote-section">
                        <div className="step-quote-section-title">Quote Options</div>

                        {addedToFolder && (
                            <div className="step-quote-added-banner">
                                Item added to your Quote Folder!
                            </div>
                        )}

                        {!addedToFolder ? (
                            <div className="step-quote-option-cards">
                                <div className="step-quote-option-card" onClick={isAnonymous ? () => this.setState({ showRegisterPrompt: true }) : this.openRfqModal}>
                                    <h3>Request a Quote</h3>
                                    <p>Submit a quote request for this configured product. We'll get back to you shortly.</p>
                                </div>
                                <div
                                    className={`step-quote-option-card ${this.state.addingToQuote ? 'disabled' : ''}`}
                                    onClick={isAnonymous ? () => this.setState({ showRegisterPrompt: true }) : (this.state.addingToQuote ? undefined : this.handleAddToQuote)}
                                >
                                    <h3>{this.state.addingToQuote ? 'Adding...' : 'Add to Quote Folder'}</h3>
                                    <p>Save this configuration to your Quote Folder to submit later or add more items.</p>
                                </div>
                            </div>
                        ) : (
                            <div className="step-quote-option-cards">
                                <div className="step-quote-option-card" onClick={this.props.onStartOver}>
                                    <h3>Configure Another Item</h3>
                                    <p>Start a new product configuration to add more items to your Quote Folder.</p>
                                </div>

                                <div className="step-quote-option-card" onClick={this.handleLeave}>
                                    <h3>Leave ConfigSelect.com</h3>
                                    <p>You're all done. Your Quote Folder is saved and you can return anytime.</p>
                                </div>
                            </div>
                        )}

                        {this.state.addToQuoteError && (
                            <div className="step-quote-message error">
                                {this.state.addToQuoteError}
                            </div>
                        )}
                    </div>

                    {/* Action Buttons */}
                    <div className="step-quote-actions">
                        <button className="step-quote-action-btn start-over" onClick={this.props.onStartOver}>
                            Start Over
                        </button>
                        {isAnonymous ? (
                            <a href="/login" className="step-quote-action-btn sign-in">Sign In</a>
                        ) : (
                            <button className="step-quote-action-btn logout" onClick={this.handleLogout}>
                                Log Out
                            </button>
                        )}
                    </div>
                </div>

                <RfqModal
                    isOpen={this.state.showRfqModal}
                    onClose={this.closeRfqModal}
                    productName={productName}
                    configurationJson={configurationJson}
                />
                <RegisterPromptModal
                    open={this.state.showRegisterPrompt}
                    onClose={() => this.setState({ showRegisterPrompt: false })}
                />
            </div>
        );
    }
}

/* istanbul ignore next */
export default connect(function(store) {
    const activeProject = getActiveProject(store);
    return {
        activeProject,
        projectUpdateParameters: getUpdateParameters(activeProject.id, store),
        projectSourceParameters: getParameters(activeProject.id, store)
    };
})(StepQuote);
